import * as yup from 'yup';

export const initialValues = {
  eventType: '',
  eventName: '',
  eventDate: '',
  email: '',
  eventNumber: '',
  customerSearsId: '',
};

export const schema = yup.object().shape({
  eventType: yup.string(),
  eventName: yup.string(),
  eventDate: yup.string(),
  email: yup.string(),
  eventNumber: yup.string(),
});
